import { cn } from "@/lib/utils";

interface LoadingStateProps {
    label?: string;
    className?: string;
}

export const LoadingState = ({
    label = "Loading…",
    className,
}: LoadingStateProps) => {
    return (
        <div
            className={cn(
                "flex h-full w-full flex-col items-center justify-center gap-3 text-muted-foreground",
                className,
            )}
        >
            <div className="h-10 w-10 animate-spin rounded-full border-2 border-primary border-t-transparent" />
            <span className="text-sm font-medium tracking-wide uppercase">
                {label}
            </span>
        </div>
    );
};

